import TermsOfServiceContent from '../../components/TermsOfServiceContent'
import { useIntl } from 'react-intl'

const TermsOfService = () => {
  const intl = useIntl()
  return <div className="flex-column mw-500px">
    <h2 className="text-center mb-2">{intl.formatMessage({id: `general.terms`})}</h2>
    <div className="overflow-y-auto mh-500px">
        <TermsOfServiceContent/>
    </div>
  </div>
}

export default TermsOfService